import { render, staticRenderFns } from "./NPagination.vue?vue&type=template&id=87bb7e02&"
import script from "./NPagination.vue?vue&type=script&lang=js&"
export * from "./NPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports